import { captureException } from 'modules/error-reporting';

let safeSessionStorage = null;

try {
    if (typeof window !== 'undefined' && window.sessionStorage) {
        // test access
        const testKey = '__test__';
        window.sessionStorage.setItem(testKey, testKey);
        window.sessionStorage.removeItem(testKey);
        safeSessionStorage = window.sessionStorage;
    }
} catch (e) {
    // leave safeSessionStorage null
    captureException(e, {
        message: 'Could not access to SessionStorage',
    });
}

export function setItemForSession(key, value) {
    try {
        if (safeSessionStorage) {
            safeSessionStorage.setItem(key, value);
        }
    } catch (e) {
        captureException(e, {
            message: 'Could not set item in SessionStorage',
            key,
            value,
        });
    }
}

export function getSessionItem(key) {
    try {
        return safeSessionStorage?.getItem(key) ?? null;
    } catch (e) {
        captureException(e, {
            message: 'Could not get item in SessionStorage',
            key,
        });
        return null;
    }
}

export function removeSessionItem(key) {
    try {
        if (safeSessionStorage) {
            safeSessionStorage.removeItem(key);
        }
    } catch (e) {
        captureException(e, {
            message: 'Could not remove item from SessionStorage',
            key,
        });
    }
}
